module.exports = __webpack_public_path__ + "static/media/about2.d7320277.jpg";